// assets
import { DashboardOutlined } from '@ant-design/icons';
import { t } from 'i18n';

// icons
const icons = {
  DashboardOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: t('Navigation'),
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: t('Dashboard'),
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
